import { color } from "minimum-ui/tokens";
import styled from "styled-components";

const Base = styled.span`
  color: ${color.basic.black};
  margin: 0;
  padding: 0;
`;

export default Base;
